import { UnreachableFunction } from 'ui/base/types';
import { PlanType } from 'services/accounts/types';

import PlanFirewallMessages from './plan_firewall_messages';

export const getPlanTypeTitle = (type: PlanType): string => {
  switch(type) {
    case PlanType.FIREWALL:
      return PlanFirewallMessages.typeTitle();
    default:
      return UnreachableFunction(type);
  }
};

export const getPlanTypeSubtitle = (type: PlanType): string => {
  switch(type) {
    case PlanType.FIREWALL:
      return PlanFirewallMessages.typeSubtitle();
    default:
      return UnreachableFunction(type);
  }
};
